import { useState } from 'react';
import { Link } from 'react-router-dom';

const AZUL = '#1FA3E8';

const LINKS = [
  ['/soluciones', 'Página Soluciones', true],
  ['/pasamanosaceroinox', 'Pasamanos Acero Inox'],
  ['/ventanasypuertaseuro', 'Ventanas y Puertas Euro'],
  ['/fachadasvidriotemplado', 'Fachadas Vidrio Templado'],
  ['/duchasymamparas', 'Duchas y Mamparas'],
  ['/techocurvo', 'Techo Curvo'],
  ['/pvcpuertasyventanas', 'PVC Puertas y Ventanas'],
  ['/aceroinox', 'Trabajos de Acero Inox'],
];

export const LandingMenu = ({ actual }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button onClick={() => setOpen((v) => !v)} data-testid="landing-menu-btn" aria-label="Menú"
        className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-bold px-3 py-2 rounded-full border border-white/20 hover:border-white/50 transition-colors">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z"/></svg>
        <span className="hidden sm:inline">Menú</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-64 bg-[#0C121A] border border-white/15 rounded-2xl shadow-2xl z-50 py-2 overflow-hidden" data-testid="landing-menu-dropdown">
            {LINKS.filter(([path]) => path !== actual).map(([path, label, destacado]) => (
              <Link key={path} to={path} onClick={() => setOpen(false)}
                data-testid={`landing-menu-link-${path.replace('/', '')}`}
                className={`block px-4 py-2.5 text-sm font-bold transition-colors ${destacado ? 'text-white hover:bg-white/10' : 'text-white/65 hover:text-white hover:bg-white/5'}`}
                style={destacado ? { borderBottom: '1px solid rgba(255,255,255,0.1)' } : {}}>
                {destacado ? (
                  <span className="flex items-center gap-2">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill={AZUL}><path d="M12 3l9 8h-3v9h-5v-6h-2v6H6v-9H3l9-8z"/></svg>
                    {label}
                  </span>
                ) : label}
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
